export const Permissions = {
  CanEditeEmployee: "CanEditeEmployee",
  CanEditeCompany: "CanEditeCompany",
  CanEditeExtraService: "CanEditeExtraService",
  CanEditeAwards: "CanEditeAwards",
  CanEditeAddtionals: "CanEditeAddtionals",
  CanEditeCoupons: "CanEditeCoupons",
  CanEditePromotions: "CanEditePromotions",
  CanEditeNotices: "CanEditeNotices",
  CanEditeReservations: "CanEditeReservations",
  CanEditeCategories: "CanEditeCategories",
  CanEditeDrinks: "CanEditeDrinks",
  CanEditeCombos: "CanEditeCombos",
  CanEditeMeals: "CanEditeMeals",
  CanEditeTables: "CanEditeTables",
  CanEditeClients: "CanEditeClients",
  CanEditeOrders: "CanEditeOrders",
  CanViewProfit: "CanViewProfit",
  CanEditeKitchen: "CanEditeKitchen",
  CanEditeCourier: "CanEditeCourier",
  CanAnswerWhatsApp: "CanAnswerWhatsApp",
  CanEditeTimeClock: "CanEditeTimeClock",
  CanChargeTapToPay: "CanChargeTapToPay",
  CanManageChecklists: "CanManageChecklists",
  CanExecuteChecklists: "CanExecuteChecklists",
} as const

export type PermissionsType = (typeof Permissions)[keyof typeof Permissions]
